import styled from 'styled-components'
import { ReactComponent as Eth } from 'assets/svg/ethereum.svg'

export const Title = styled.h1`
  font-size: 18px;
  font-weight: 500;
`

export const PageTitle = styled(Title)`
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.small};
  color: inherit;
  cursor: pointer;
  display: inline-block;
  margin-bottom: 1rem;
  text-decoration: none;
  transition: ${({ theme }) => theme.TRANSITION.fast};

  &:hover {
    color: ${({ theme }) => theme.purple1};
  }
`

export const StatsWrapper = styled.div`
  background-color: ${({ theme }) => theme.bg3};
  border-radius: ${({ theme }) => theme.BORDER_RADIUS.smallest};
  padding: 1rem 1.2rem;
`

export const Grid = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
`

export const Divider = styled.div`
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin: 1rem 0;
`

export const NftLogo = styled.img`
  border-radius: 50%;
  height: 30px;
  object-fit: cover;
  width: 30px;
`

export const EthIcon = styled(Eth)`
  height: auto;
  width: 12px;
`

export const PriceChange = styled.div<{ isIncreasing: boolean }>`
  background-color: ${({ isIncreasing, theme }) => (isIncreasing ? theme.green2 : theme.red4)};
  border-radius: 4px;
  padding: 0.1rem 0.4rem;
`

export const InfoText = styled.div`
  font-size: 0.9rem;
  margin-top: 0.5rem;
`

export const InfoTextBold = styled(InfoText)`
  font-weight: 500;
`
